import React, { useState, useEffect } from "react";
import { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Typography,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { toast } from 'react-toastify';
import { serverUrl } from "../../server";
import Cookies from "js-cookie";
import { RoleContext } from "../../RoleContext";
import Modal from 'react-modal';
import ClipLoader from "react-spinners/ClipLoader";

const defaultTheme = createTheme();

const modalStyles = {
  content: {
    width: "400px",
    height: "200px",
    margin: "auto",
  },
};

const spinnerContainerStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1000,
};

const GetBennes = () => {
  Modal.setAppElement("#root");
  const userRole = useContext(RoleContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [loadingInProgress, setLoading] = useState(false);
  const token = Cookies.get("jwt");
  const [bennes, setBennes] = useState([]);
  const [selectedBenne, setSelectedBenne] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const navigate = useNavigate();

  const openModal = (benne) => {
    setSelectedBenne(benne);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedBenne(null);
    setModalOpen(false);
  };

  const deleteBenne = (id) => {
    const token = Cookies.get('jwt');
    axios
      .delete(`${serverUrl}/api/benne/deletebenne/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        if (response.data.success) {
          toast.success('Benne supprimée avec succès');
          // Refresh the list of bennes after deletion
          const token = Cookies.get('jwt');
          axios
            .get(`${serverUrl}/api/benne/getbennes`, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            })
            .then((response) => {
              setBennes(response.data.bennes);
            })
            .catch((error) => {
              console.error(error);
            });
          setTimeout(() => {
            closeModal();
          }, 1000);
        } else {
          toast.error('Erreur lors de la suppression de la benne');
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error('Une erreur est survenue lors de la suppression');
        setTimeout(() => {
          closeModal();
        }, 1000);
      });
  };

  useEffect(() => {
    const fetchBennes = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${serverUrl}/api/benne/getbennes`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setBennes(response.data.bennes);
        setDataLoaded(true);
      } catch (error) {
        console.error(error);
        toast.error('Erreur lors du chargement des bennes');
      } finally {
        setLoading(false);
      }
    };

    fetchBennes();
  }, [token]);

  return (
    <>
      {loadingInProgress && (
        <div style={spinnerContainerStyles}>
          <ClipLoader
            color="#1976d2"
            loading={loadingInProgress}
            size={50}
            aria-label="Loading Spinner"
          />
        </div>
      )}
      {dataLoaded && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>N°</TableCell>
                <TableCell>Immatriculation</TableCell>
                <TableCell>Prestataire</TableCell>
                {userRole === "admin" && <TableCell>Actions</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {bennes.map((benne, index) => (
                <TableRow key={benne.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{benne.immat}</TableCell>
                  <TableCell>{benne.proprio_nom}</TableCell>
                  {userRole === "admin" && (
                    <TableCell>
                      <Button
                        onClick={() => {
                          navigate(`/dashboard/updatebenne/${benne.id}`);
                        }}
                      >
                        <EditIcon />
                      </Button>
                      <Button onClick={() => openModal(benne)}>
                        <DeleteIcon />
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Modal isOpen={modalOpen} onRequestClose={closeModal} ariaHideApp={false} style={modalStyles}>
        {selectedBenne && (
          <>
            <h2>Confirmation</h2>
            <p>Voulez-vous vraiment supprimer cette benne ?</p>
            <Button onClick={() => deleteBenne(selectedBenne.id)}>Confirmer</Button>
            <Button onClick={closeModal}>Annuler</Button>
          </>
        )}
      </Modal>
    </>
  );
};

export default GetBennes;
